/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import GradientButton from '../MUICustomButton/GradientButton';
import type { TableColumn } from 'react-data-table-component';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import MUIModal from '../MUIModal/MUIModal';
import AddSupressionList from './AddSupressionList';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { deleteList, getAllSuppressionListByClientId } from 'src/services/suppressionListService';
import moment from 'moment';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { ARE_YOU_SURE, DELETE_SUPPRESSION_LIST } from 'src/constants/constant';
import { NotificationManager } from 'react-notifications';
import EditSuppressionList from './EditSuppressionList';
import { set } from 'lodash';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface SuppressionListPropType {
    suppressionList: any;
    suppressionListData: any[];
}

interface ApiResponse {
    status: number;
    data: {
        data: SuppressionListPropType[];
        result: number;
    };
}

const ITEM_HEIGHT = 48;

function SuppressionList(): JSX.Element {

    const { user } = useSelector((state: RootState) => state.auth);

    const [addListModalOpen, setAddListModalOpen] = useState<boolean>(false);
    const [suppressionList, setSuppressionList] = useState<any[]>([]);
    const [suppressionListSearchData, setSuppressionListSearchData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
    const [openDeleteModal, setOpenDeleteModal] = React.useState<boolean>(false);
    const [listInfoData, setListInfoData] = React.useState<any>();
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false);
    const [openEditModal, setOpenEditModal] = useState<boolean>(false);
    const [suppressionListId, setSuppressionListId] = useState<any>(null);

    useEffect(() => {
        getSuppressionListData();
    }, [user]);

    const getSuppressionListData = (): void => {
        
        const ClientId = user?.clientId ?? 0;
        setLoading(true);
        getAllSuppressionListByClientId(ClientId)
            .then((response: ApiResponse) => {
                if (response.status === 200 && response.data.result === 1) {
                    const data: any = response.data.data;
                        let suppressionListArr: any[] = [];
                        if (data && data.length > 0) {
                            data.map((item: SuppressionListPropType) => {
                                
                                suppressionListArr.push(item.suppressionList);
                            });
                            
                        }
                        setSuppressionList(suppressionListArr);
                        setSuppressionListSearchData(suppressionListArr);
                } else {
                    console.error("Failed to fetch suppression list data");
                }
            })
            .catch((error) => {
                console.error("Error fetching suppression list data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
            const { value } = event.target;
            let suppressionListArr = [...suppressionList]
            if (value !== "") {
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
                suppressionListArr = suppressionListArr && suppressionListArr.filter((list: any) => {
                    return list.title.toLowerCase().search(value.toLowerCase()) >= 0
                })
            }
            setSuppressionListSearchData(suppressionListArr)
    }

    const handleRefreshPage = (): void => {
        setAddListModalOpen(false)
        setOpenEditModal(false)
        setSuppressionListId(null);
        getSuppressionListData()
    }

    const handleAddList = (): void => {
        // Implement add list logic here
        setAddListModalOpen(true);
    };

    const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
            // anchorActionEl[id] = event.currentTarget
            setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
    }

    const handleEditClick = (id: number): void => {
        setSuppressionListId(id);
        setOpenEditModal(true);
    }

    const handleDeleteSuppression = (id: number, title: string): void => {
        setListInfoData({ id, title });
        setOpenDeleteModal(true)
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }

    const handleDeleteListClose = (): void => {
        setOpenDeleteModal(false);
        setListInfoData(null);
    }

    const handleDeleteListConfirm = (): void => {
        if (listInfoData) {
            setIsModalSaveLoading(true);
            const modifiedById = user?.id ?? 0;
            deleteList(listInfoData.id, modifiedById).then((response: any) => {
                if (response.status === 200 && response.data.result === 1) {
                    console.log("Suppression List deleted successfully:", response.data);
                    NotificationManager.success("Suppression List deleted successfully")
                    getSuppressionListData();
                }
            }).catch((error: any) => {
                console.error("Error deleting Suppression List:", error);
                NotificationManager.error('Error deleting Suppression List');
            }).finally(() => {
                setIsModalSaveLoading(false);
                setOpenDeleteModal(false);
                setListInfoData(null);
            });

        }

    }

    const columns: TableColumn<any>[] = [
        {
            name: 'Title',
            selector: (row: any) => row.title,
            sortable: true,
            width: '25%',
        },
        {
            name: 'Type',
            selector: (row: any) => row.suppressionType,
            sortable: true,
            width: '18%',
        },
        {
            name: 'Count of Emails/Domains',
            selector: (row: any) => row.itemCount,
            sortable: true,
            width: '18%',
            center: true,
        },
        {
            name: 'Created',
            selector: (row: any) => moment(row.createdDate).format("MM/DD/YYYY"),
            sortable: true,
            width: '18%',
        },
        {
            name: 'Actions',
            cell: (row: any) => {
                return (
                    <div className='flex items-center'>
                        <div className="icon-hover-container" onClick={() => handleEditClick(row.suppressionListId)}>
                            {/* <Link to={{ pathname: `/campaigns/edit-campaign/${row.campaignId}` }} state={{ campaigndata: row }} style={{ width: '20px' }}> */}
                            {/* <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="Edit Campaign" className="icon-hover" /> */}
                            <HugeiconsIcon
                                icon={PencilEdit02Icon}
                                size={20}
                                color="#3A3A3A"
                                strokeWidth={0.2}
                            />
                            {/* </Link> */}
                        </div>
                        <div className='flex'>
                            <IconButton
                                aria-label="more"
                                id="long-button"
                                // aria-controls={open ? 'long-menu' : undefined}
                                // aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={(e) => handleActionClick(e, row.suppressionListId)}
                            >
                                <HugeiconsIcon
                                    icon={MoreVerticalSolidRounded}
                                    size={20}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                />
                            </IconButton>
                            <Menu
                                id={`${row.suppressionListId}`}
                                className='table-action-menu'
                                MenuListProps={{
                                    'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorActionEl[row.suppressionListId]}
                                open={Boolean(anchorActionEl[row.suppressionListId])}
                                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.suppressionListId]: null })}
                               slotProps={{ paper: {
                                    style: {
                                        maxHeight: ITEM_HEIGHT * 4.5,
                                        width: '18ch',
                                    },
                                }}}
                            >


                                <MenuItem onClick={() => handleDeleteSuppression(row.suppressionListId, row.title)}>
                                    <span style={{ paddingLeft: '15px', cursor: row.isBrandInUse !== true ? 'pointer' : 'not-allowed', color: row.isBrandInUse === true ? '#A0A0A0' : '#F13139' }}>Delete</span>
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                )
            },
            width: '15%',
        }
    ]

    return (       
                <>
                    <h2 className="text-2xl font-semibold text-title">Suppression List</h2>
                    <div className="mt-[20px] mb-[20px] live-outreach-container">
                        <Grid container spacing={2} alignItems={'center'}>
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <div className="w-full">
                                    <input
                                        type="text"
                                        placeholder="Search by title"
                                        className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                                        onChange={handleSearch}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={8} className='bulk-action'>
                                <div className="justify-end flex">
                                    <GradientButton color='red' onClick={handleAddList}>
                                        <span style={{
                                            width: "20px",
                                            height: "20px",
                                            background: "#fff",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "50px",
                                            marginRight: "5px"
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                                                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                                                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                                            </svg>
                                        </span>
                                        Add New Suppression List
                                    </GradientButton>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className='data-table-container mb-10 custom-table-container te-table-container'>
                        <CustomDataTable
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            columns={columns}
                            data={suppressionListSearchData}
                            pagination
                        //   selectableRows
                            progressPending={loading}
                        />
                    </div>

                    <MUIModal title='New Suppression List' openModal={addListModalOpen} closeModal={() => setAddListModalOpen(false)} width={'50%'} >
                        <AddSupressionList onClose={() => setAddListModalOpen(false)} onRefresh={handleRefreshPage} />
                    </MUIModal>

                    <MUIModal title='Edit Suppression List' openModal={openEditModal} closeModal={() => setOpenEditModal(false)} width={'50%'} >
                        <EditSuppressionList id={suppressionListId} onClose={() => setOpenEditModal(false)} onRefresh={handleRefreshPage}/>
                    </MUIModal>

                    <BootstrapDialog
                        onClose={handleDeleteListClose}
                        aria-labelledby="customized-dialog-title"
                        open={openDeleteModal}
                        PaperProps={{
                            sx: {
                                width: '550px',
                                height: '200px'
                            },
                        }}
                    >
                        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                            Delete Suppression List
                        </DialogTitle>

                        <IconButton
                            aria-label="close"
                            onClick={handleDeleteListClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <HugeiconsIcon
                                icon={MultiplicationSignStrokeStandard}
                                size={24}
                                color="currentcolor"
                                strokeWidth={0.5}
                            />
                        </IconButton>
                        <DialogContent>
                            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_SUPPRESSION_LIST} <span className='font-semibold'>{listInfoData?.title}</span>?</p>
                        </DialogContent>
                        <DialogActions sx={{ background: '#F9F9F9' }}>

                            <OutlineButton color='gray' onClick={handleDeleteListClose} width='100px'>Cancel</OutlineButton>

                            <GradientButton type='button' color='red' onClick={handleDeleteListConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                        </DialogActions>
                    </BootstrapDialog>
                </>
    )
}

export default SuppressionList